/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does this verify the signature?`)
};

const es_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Verifica esto la firma?`)
};

const de_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird die Signatur verifiziert?`)
};

const nl_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieert dit de handtekening?`)
};

const fr_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela vérifie-t-il la signature ?`)
};

const it_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo verifica la firma?`)
};

const pt_br2_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso verifica a assinatura?`)
};

const pt_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto verifica a assinatura?`)
};

const ja_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シグネチャを検証しますか？`)
};

const zh_jw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个工具会验证签名吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq1_q", locale)
	if (locale === "en") return en_jw_faq1_q(inputs)
	if (locale === "es") return es_jw_faq1_q(inputs)
	if (locale === "de") return de_jw_faq1_q(inputs)
	if (locale === "nl") return nl_jw_faq1_q(inputs)
	if (locale === "fr") return fr_jw_faq1_q(inputs)
	if (locale === "it") return it_jw_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq1_q(inputs)
	if (locale === "pt") return pt_jw_faq1_q(inputs)
	if (locale === "ja") return ja_jw_faq1_q(inputs)
	return zh_jw_faq1_q(inputs)
};